import { Icon } from "./Icon.tsx";

/** Snowflake icon — distinguishes a snow zone from a runoff zone on the cards (SubBasinCanvas.tsx), where both zone types share the same group style. */
export function SnowIcon() {
  return (
    <Icon>
      <line x1="12" y1="3.5" x2="12" y2="20.5" />
      <line x1="4.64" y1="7.75" x2="19.36" y2="16.25" />
      <line x1="19.36" y1="7.75" x2="4.64" y2="16.25" />
      <circle cx="12" cy="3.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="12" cy="20.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="4.64" cy="7.75" r="1" fill="currentColor" stroke="none" />
      <circle cx="19.36" cy="16.25" r="1" fill="currentColor" stroke="none" />
      <circle cx="19.36" cy="7.75" r="1" fill="currentColor" stroke="none" />
      <circle cx="4.64" cy="16.25" r="1" fill="currentColor" stroke="none" />
    </Icon>
  );
}
